var exports = {
  "pageViewer": "pageViewer-X3pFU",
  "hoverScale": "hoverScale-X3pFU",
  "scaleAnimation": "scaleAnimation-X3pFU",
  "caption": "caption-X3pFU",
  "fullHeightNav": "fullHeightNav-X3pFU",
  "prev": "prev-X3pFU",
  "next": "next-X3pFU",
  "mobile": "mobile-X3pFU",
  "controlButton": "controlButton-X3pFU",
  "fulltextContainer": "fulltextContainer-X3pFU",
  "splitPane": "splitPane-X3pFU",
};

__webpack_require__.r(module.exports = exports);
